module.exports = __webpack_public_path__ + "img/avatar1.02609043.png";